module.exports = __webpack_public_path__ + "img/bosch.60eb4b16.svg";